import { OPTIONS_PER_PAGE } from "../constants/optionsConfig";

const getCurrentproductCount = (pageDetails) => {
    const { current_page, total_count } = pageDetails;
    if(current_page * OPTIONS_PER_PAGE.PRODUCTS > total_count){ 
      return total_count
    } else {
      return current_page * OPTIONS_PER_PAGE.PRODUCTS
    }
  }
   export default getCurrentproductCount;

   export function extractProductValues(data) {
    return data.map(item => item.product);
  }

  export const getFormattedDate = (date) => {
    if (!date) {
      return null;
    }
    const isoDate = date;
    const tempDate = new Date(isoDate);
    const formattedDate = tempDate.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });

    return formattedDate;
}

export const  isMatchingItem = (bagItems, selectedSize, selectedColor, id) => {
  if(!bagItems?.length)
    return false;
  return bagItems?.some(item => 
      item?.color === selectedColor && item?.product_id === id && selectedSize === item?.size
  );
}

export const getMatchingItemSizes = (bagItems, selectedColor, id) => {
  if (!bagItems?.length) return [];

  return bagItems
    .filter(item => item?.color === selectedColor && item?.product_id === id)
    .map(item => item?.size);
};

export const roundToTwoDecimalPlaces=(num)=> {
  return parseFloat(num.toFixed(2));
}

export function toTwoDecimalPlaces(value) {
  return parseFloat(value).toFixed(2);
}
